var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"block block-100",attrs:{"id":"attachments"}},[_vm._m(0),_c('Attachments')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block_header"},[_c('table',[_c('tbody',[_c('tr',[_c('td',[_c('label')])])])])])
}]

export { render, staticRenderFns }